import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RelatorioFiscal } from '@/features/relatorio/page/fiscal/RelatorioFiscal';

const searchSchema = z.object({
    tab: z.enum(['fiscal', 'notas-fiscais']).default('fiscal'),
});

export const Route = createFileRoute('/a/relatorio/fiscal/')({
    component: RelatorioFiscal,
    validateSearch: searchSchema,
});
